import apiClient from '../axios';

export function all(countryId) {
  return apiClient
    .get(`/country/${countryId}/sports/activated`);
}

export function categories(countryId, sportId) {
  return apiClient.get(`/public/country/${countryId}/sports/${sportId}/categories`);
}

export function competitions(countryId, sportId, categoryId) {
  return apiClient.get(`/public/country/${countryId}/sports/${sportId}/categories/${categoryId}/competitions`);
}

export function sportPlaces(countryId, sportId) {
  return apiClient.get(`/public/country/${countryId}/sports/${sportId}/places`);
}

export function sportPlacesByCounty(countryId, sportId, countyId) {
  return apiClient.get(`/public/country/${countryId}/sports/${sportId}/counties/${countyId}/places`);
}
